<template>
  <div class="chat-header">
    <div class="text">
      <div class="name">{{ title }}</div>
      <div class="question">{{ question }}</div>
    </div>
    <img :src="avatarUrl" alt="AI Avatar" />
  </div>
</template>

<script>
export default {
  name: "ChatHeader",
  props: {
    title: {
      type: String,
      default: "我是石基ai小石~",
    },
    question: {
      type: String,
      default: "今天我可以为您做什么？",
    },
    avatarUrl: {
      type: String,
      default:
        "https://wsb2c-shop.oss-cn-hangzhou.aliyuncs.com/2024/icon/iegoai.png",
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-header {
  width: 100%;
  height: 153px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 0 0 6%;
  box-sizing: border-box;

  img {
    width: 175px;
    height: 170px;
  }

  .text {
    margin-top: 70px;

    .name {
      font-size: 18px;
      font-weight: bold;
      background-image: linear-gradient(to right, #73bdf5, #6e46b5, #a9479f);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .question {
      margin-top: 12px;
      font-size: 13px;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(to right, #73bdf5, #6e46b5, #a9479f);
    }
  }
}
</style>

